<template>
  <div>
    <transition name="screen" mode="out-in">
      <IntroScreen v-if="activeLobbyPhaseScreen == 'GAME_INTRO_SCREEN'" />
      <LobbyScreen v-else-if="activeLobbyPhaseScreen == 'LOBBY_SCREEN'" />
    </transition>
  </div>
</template>

<script setup lang="ts">
import IntroScreen from '@/components/screens/game-intro/IntroScreen.vue'
import LobbyScreen from '@/components/screens/game-intro/LobbyScreen.vue'

import { useGameStore } from '@/stores/game'
import { storeToRefs } from 'pinia'

const { activeLobbyPhaseScreen } = storeToRefs(useGameStore())
</script>

<style scoped></style>
